"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
function Channels() {
    var channels = ra_fetch_1.useApi('backend').index('public.sports', {
        ordered_channels: true,
        videos_count: true
    })[0];
    if (channels.loading) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return react_1.default.createElement(storybook_1.Layouts.Container, { className: 'storybook-pages-site-channels' }, channels.data.map(function (channel, index) {
        return react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(storybook_1.Channels.Info, { className: 'storybook-pages-site-channels-info', key: index, image: channel.logo, title: channel.label, description: channel.videos_count }),
            react_1.default.createElement("div", { className: 'storybook-pages-site-channels-sports' }, channel.ordered_channels.map(function (sports, index) {
                return react_1.default.createElement("a", { href: '/kanalen/' + sports.name },
                    react_1.default.createElement(storybook_1.Channels.Card, { className: 'storybook-pages-site-channels-card', key: index, image: sports.logo, title: sports.label }));
            })));
    }));
}
exports.default = Channels;
